export default "__VITE_ASSET__C0ytW3RV__"